import * as ValidateModel from '../shared/ValidateModel';
import Designs from '../objects/graphicsLibrary/designs';
import Design from '../objects/graphicsLibrary/design';

const fields = {
    ID: 'id',
    ID_PRODUCT: 'idProduct',
    DESIGN_NAME: 'designName',
    GARMENT_NAME: 'garmentName',
    DATE_ADD: 'dateAdd',
    DATE_UPD: 'dateUpd',
};

class DesignsSimpleConverter {
    static convertOne = (data: any): Design => {
        ValidateModel.isObject(data, 'data');
        const {
            [fields.ID]: id,
            [fields.ID_PRODUCT]: idProduct,
            [fields.DESIGN_NAME]: designName,
            [fields.GARMENT_NAME]: garmentName,
            [fields.DATE_ADD]: dateAdd,
            [fields.DATE_UPD]: dateUpd,
        } = data;
        return new Design(
            id,
            idProduct,
            designName,
            garmentName,
            dateAdd,
            dateUpd
        );
    };

    static convertAllToArray = (data: any[]): Design[] => {
        ValidateModel.isArray(data, 'data');
        return data.map((item) => DesignsSimpleConverter.convertOne(item));
    };

    static convertAll = (data: any[]): Designs => {
        ValidateModel.isArray(data, 'data');
        return new Designs(DesignsSimpleConverter.convertAllToArray(data));
    };
}

export default DesignsSimpleConverter;
